import React, { forwardRef, ForwardRefRenderFunction, useState } from 'react';
import classNames from 'classnames';

import { getImageUrlWithFormat } from '~/utils';

const defaultImageFormat = '.png';

interface IImageBasicProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  alt: string;
  className?: string;
  placeholderClassName?: string;
  src?: string;
  path?: string;
}

const ImageBasicRenderer: ForwardRefRenderFunction<
  HTMLImageElement,
  IImageBasicProps
> = (
  {
    src,
    alt,
    path,
    // fixme: it exists only because cards placeholder have rounded edges and needs scaling
    placeholderClassName,
    className,
    onError,
    ...props
  },
  ref,
) => {
  const [errored, setErrored] = useState(false);

  const showPlaceholder = errored || !path;
  return (
    <img
      alt={alt}
      ref={ref}
      src={
        !showPlaceholder ? getImageUrlWithFormat(path, defaultImageFormat) : src
      }
      className={classNames(className, placeholderClassName && showPlaceholder)}
      loading="lazy"
      onDragStart={(e) => e.preventDefault()}
      {...props}
      onError={(e) => {
        setErrored(true);
        if (onError) {
          onError(e);
        }
      }}
    />
  );
};

const ImageBasic = forwardRef<HTMLImageElement, IImageBasicProps>(
  ImageBasicRenderer,
);

export default ImageBasic;
